import { useFormattedText, TUseFormattedTextProps } from './useFormattedText'

export type TFormattedTextProps = TUseFormattedTextProps

export const FormattedText = (props: TFormattedTextProps) => {
  const formattedText = useFormattedText(props)

  return <>{formattedText}</>
}
